import { render, staticRenderFns } from "./RecomVouchers.vue?vue&type=template&id=a11966f2"
import script from "./RecomVouchers.vue?vue&type=script&lang=js"
export * from "./RecomVouchers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports